import React from "react";

const ButtonLayout = ({ text, imgSrc, className, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={` w-[100%] h-[48px] py-[12px] px-[24px] bg-purple-gradient rounded-[56px] flex justify-center items-center shadow-button-shadow `}
    >
      {imgSrc && <img src={imgSrc} alt="Button Icon" className="mr-1" />}
      <div className="text-white text-[14px] font-semibold">{text}</div>
    </button>
  );
};

export default ButtonLayout;
